import { Injectable } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { selectUserBusinessDetails, selectUserDetails } from 'src/app/ngrx/user/user.selectors';
import { VerifiedBusinessDialogComponentComponent } from '../components/verified-business-dialog-component/verified-business-dialog-component.component';

@Injectable({
  providedIn: 'root',
})
export class VerifiedBusinessGuard implements CanActivate, CanActivateChild {
  constructor(private store$: Store, private dialog: MatLegacyDialog, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store$.select(selectUserDetails).pipe(
      map((user) => {
        const {
          businesses: [business],
        } = user;
        if (business.status === 'verified') {
          return true;
        }

        this.dialog.open(VerifiedBusinessDialogComponentComponent, { width: '90vw', maxWidth: '450px' });

        if (route['_lastPathIndex'] === 0) {
          this.router.navigate(['/']);
        }

        return false;
      })
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
